/**
 * The newman module is the application core module.
 *
 * @module newman
 */

angular.module('newman', [
  'stack',
  'routes',
  'components',
  'content',
  'services',
  'ngMessages'
])
.config(
  [
    '$locationProvider',
    '$urlRouterProvider',
    function ($locationProvider, $urlRouterProvider) {
      'use strict';

      // Enable html5 push state.
      $locationProvider.html5Mode({ enabled: true, requireBase: false });
      $locationProvider.hashPrefix('!');

      // Redirect for unmatched urls.
      $urlRouterProvider.otherwise(function ($injector) {
        var state = $injector.get('$state');
        if (state.get('routes.cases')) {
          state.go('routes.cases');
        } else {
          state.go('routes.notFound');
        }
      });
    }
  ]
)
.run(
  [
    '$rootScope',
    '$state',
    '$window',
    function ($rootScope, $state, $window) {
      'use strict';

      // set global rootpath
      $rootScope.rootpath = $window.rootpath;

      $rootScope.$state = $state;

      /**
       * Method returns true if an enumerable object contains
       * no values (no enumerable own-properties). For strings
       * and array-like objects the isEmpty() method checks if
       * the length property is 0. This method is available
       * globally and can be leveraged within templates.
       *
       * @param {Mixed} value - context value
       * @return {boolean} True or False
       */
      $rootScope.isEmpty = function isEmpty(value) {
        return _.isEmpty(value);
      };
    }
  ]
);
